/* eslint-disable import/prefer-default-export */

import { CategoryType } from '../../shared/components/CategoryLabel/models';
import { ProductBundleOption } from './models';

export function courseTypeDescription(type: CategoryType) {
  if (type === 'eLearning') return 'Online Course';
  return type;
}

export function isBundleOptionChapter(bundleOption: ProductBundleOption) {
  return bundleOption.title.toLowerCase().includes('chapter');
}
